<!-- 中继详情 -->
<template>
    <relayDetail 
      :isDetailShow.sync="isDetailShow"
      :title="title"
      :detailObj="detailObj"
      :deviceProperty="deviceProperty"
      v-bind="$attrs"
      ref="detailDialog"
      :detailNetObj="netObj"

      :deviceType="deviceType"></relayDetail>
</template>

<script>
import relayDetail from "./component/relayDetail.vue";
import { relayDetailInfo } from "@/api/modules/relay";
import bus from "@/utils/bus";
export default {
    props:['show'],
    components:{
        relayDetail
    },
    data(){
        return {
            isDetailShow:false,
            title:'',
            detailObj:{},
            deviceProperty:{},
            netObj:{},
            deviceType:{},
            relay:{
                id:null,
                name:null
            }
        }
    },
    watch:{
        isDetailShow(newval){
            this.$emit("update:show",newval);
        }
    },
    methods:{
        detailFn(id=this.relay.id,name=this.relay.name) {
            this.isDetailShow = true
            this.title = `[${name}]${this.$t('public.details')}`
            // this.$nextTick(() => {
            //   this.$refs['detailDialog'].claerDataInit();
            // });
            relayDetailInfo(id).then(({ result }) => {
                const url  = `${result.relay.fullPath || result.relay.scopeName}`;
                const pictureBase64=result.relay.pictureBase64 || result.deviceType.pictureBase64;
                this.detailObj = Object.assign({}, { ...result.relay }, { url ,pictureBase64});
                this.netObj = Object.assign({}, { ...result.netConfig });
                this.deviceType=result.deviceType;
                this.deviceProperty=result.deviceProperty || {};
            })
        },
    },
    mounted(){
        bus.$on("relayParam",(id,name)=>{
            this.relay={id,name};
            this.detailFn(id,name);
        })
    },
    beforeDestroy(){
        bus.$off("relayParam");
    }
}
</script>

<style>

</style>